import { render, staticRenderFns } from "./SignSLA.vue?vue&type=template&id=24f8a43c&scoped=true&"
import script from "./SignSLA.vue?vue&type=script&lang=js&"
export * from "./SignSLA.vue?vue&type=script&lang=js&"
import style0 from "./SignSLA.vue?vue&type=style&index=0&id=24f8a43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8a43c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f8a43c')) {
      api.createRecord('24f8a43c', component.options)
    } else {
      api.reload('24f8a43c', component.options)
    }
    module.hot.accept("./SignSLA.vue?vue&type=template&id=24f8a43c&scoped=true&", function () {
      api.rerender('24f8a43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/productEngagement/SignSLA/SignSLA.vue"
export default component.exports